export const FETCH_COURSE_PERCENTAGE_COMPLETED =
  'FETCH_COURSE_PERCENTAGE_COMPLETED'
export const FETCH_COURSE_PERCENTAGE_COMPLETED_SUCCESS =
  'FETCH_COURSE_PERCENTAGE_COMPLETED_SUCCESS'
export const FETCH_COURSE_PERCENTAGE_COMPLETED_FAILURE =
  'FETCH_COURSE_PERCENTAGE_COMPLETED_FAILURE'
export const FETCH_COURSE_PERCENTAGE_COMPLETED_CANCEL =
  'FETCH_COURSE_PERCENTAGE_COMPLETED_CANCEL'
